
import { useNavigation } from '@react-navigation/native';
import { APIData } from '../constants';
import useRest from './base/useRest';

// CONTACTS

const preffix = "feeds";

export const useFeed = (options?: APIData) => {
    return useRest(`${preffix}/`, options);
};

export const useFeedRefresh = (options?: APIData) => {
    return useRest(`${preffix}/refresh`, options);
};

export const useFeedInstitutionItems = (options?: APIData) => {
    return useRest(`${preffix}/feed-institution-items`, options);
};

export const useFeedInstitutionItemsUpdate = (options?: APIData) => {
    return useRest(`${preffix}/feed-institution-items/update`, options);
};